import { useLocalization } from '@/services/localizationService';
import Link from 'next/link';

export default function PrivacyNote() {
  const { t, data } = useLocalization();
  return (
    <div className="M14 text-overlay-black-60 my-5 text-left">
      {t(data.support.privacyNote, {
        accent: (text) => (
          <span className="cursor-pointer">
            <Link href="/privacy-and-cookie-policy">
              <u>{text}</u>
            </Link>
          </span>
        ),
      })}
    </div>
  );
}
